var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg"}),_c('div',{staticClass:"i-pop-box"},[_c('Spinner',{attrs:{"size":48,"message":'Loading...',"font-size":14,"line-size":7,"text-fg-color":'#fff'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }